import { useTranslation } from 'next-i18next'
import { Text } from 'ui/src/components/Text/Text'
import { useSelectedOffer } from '@/features/priceCalculator/PurchaseFormV2/useSelectedOffer'
import { usePriceCalculatorStep } from '@/features/priceCalculator/usePriceCalculatorStep'
import { root } from './ProductSpecs.css'

export function ProductSpecs() {
  const { t } = useTranslation('purchase-form')
  const [selectedOffer] = useSelectedOffer()
  const { step } = usePriceCalculatorStep()

  // Accident Insurance doesn't include deductible nor addon and its exposure doesn't add too much value.
  // We also just want to show the specs when the user is on the viewOffers step.
  const hideSpecs = !selectedOffer || selectedOffer.product.name === 'SE_ACCIDENT' || step !== 'viewOffers'
  if (hideSpecs) {
    return null
  }

  const displayItemKeys = ['numberCoInsured', 'breeds', 'mileage'] as const

  const specs = [
    { value: selectedOffer.exposure.displayNameShort },
    ...displayItemKeys.map((key) => ({
      value: selectedOffer.displayItems.find((item) => item.key === key)?.displayValue ?? null,
    })),
    {
      value: selectedOffer.deductible?.displayName
        ? t('PRODUCT_SPECS_DEDUCTIBLE_LABEL', { amount: selectedOffer.deductible.displayName })
        : null,
    },
    {
      value: selectedOffer.addons.find((addon) => addon.isSelected)?.variant.displayName ?? null,
    },
  ].filter((spec) => spec.value !== null)

  return (
    <div className={root}>
      {specs.map((spec, index) => (
        <Text key={index} color="textSecondary" size="xs">
          {spec.value}
        </Text>
      ))}
    </div>
  )
}
